
class Wishlist {
  constructor() {
    this.headerButton = document.querySelector('.header__wishlist-icon');
    this.mobileDrawerButton = document.querySelector('.menu-drawer__wishlist');
    this.drawer = document.querySelector('.wishlist-drawer');
    this.drawerSkeleton = this.drawer.querySelector('.wishlist-drawer__skeleton-container');
    this.drawerItems = this.drawer.querySelector('.wishlist-drawer__items');
    this.drawerItemTemplateHTML = document.querySelector('#wishlist-drawer-card').innerHTML;
    this.drawerItemTemplate = _.template(this.drawerItemTemplateHTML);
    this.drawerCloseButton = this.drawer.querySelector('.wishlist-drawer .drawer__close');
    this.drawerLoading = this.drawer.querySelector('.wishlist-drawer__loading');
    this.overlay = document.querySelector('#Modal-Overlay');
    this.wishlistButtons = document.querySelectorAll('[data-wishlist-button]');

    this.wishlistItems = [];
    this.storageKey = 'chaballo--wishlist';
    this.removedItemsCache = [];
    this.appDataLoaded = false;

    this.init();
  }

  init() {
    this.drawer.classList.remove('hidden');
    this.setEventListeners();
    this.fetchLocalData();
    this.fetchAppData();
  }

  setEventListeners() {
    this.wishlistItemsUpdated = new Event("wishlistItemsUpdated");

    // Event listeners relating to header button
    this.headerButton.addEventListener('click', this.drawerOpen.bind(this));
    this.mobileDrawerButton.addEventListener('click', this.drawerOpen.bind(this));
    this.drawerCloseButton.addEventListener('click', this.drawerClose.bind(this));
    this.overlay.addEventListener('click', this.drawerClose.bind(this));
    window.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.drawerClose());

    // Event listener for wishlist buttons
    if (this.wishlistButtons) {
      this.wishlistButtons.forEach(button => {
        button.addEventListener('click', () => {
          this.toggleButton(button)
        })
      })
    }

    // Event listener to populate drawer on data load
    document.addEventListener('appDataLoaded', () => {
      this.processAppData();
      document.dispatchEvent(this.wishlistItemsUpdated);
      this.appDataLoaded = true;
    });

    document.addEventListener('wishlistItemsUpdated', () => {
      this.updateLocalStorage();
      this.renderDrawerContents();
      this.setDrawerItemRemoves()
      this.setHeaderIndicator();
      this.setWishlistButtons();
    })

    window.addEventListener('storage', () => {
      this.wishlistItems = JSON.parse(localStorage.getItem(this.storageKey));
      
      this.renderDrawerContents();
      this.setDrawerItemRemoves()
      this.setHeaderIndicator();
      this.setWishlistButtons();
    })
  }

  processAppData() {
    this.appData.items.forEach(item => {
      if (!this.removedItemsCache.includes(item.id)) {
        this.addToWishlistItems({
          handle: item.handle,
          id: item.id,
          image: item.image,
          title: item.title,
          variant_id: item.variant_id,
          variant_price: item.variant_price,
          variant_title: item.variant_title,
        })
      }
    })
  }

  renderDrawerContents() {
    this.handleEmptyDrawer();

    this.drawerItems.innerHTML = '';
    
    this.wishlistItems.forEach(item => {
      const li = document.createElement('li');
      li.innerHTML = this.drawerItemTemplate(item);
      this.drawerItems.appendChild(li);
    })

    this.drawerSkeleton.classList.add('hidden');
    this.drawerItems.classList.remove('hidden');
  }

  handleEmptyDrawer() {
    if (this.wishlistItems.length >= 1 && this.drawer.classList.contains('is-empty')) {
      this.drawer.classList.remove('is-empty');
    } else if (this.wishlistItems.length === 0 && !this.drawer.classList.contains('is-empty')) {
      this.drawer.classList.add('is-empty');
    }
  }

  setDrawerItemRemoves() {
    this.drawerItems.querySelectorAll('.wishlist-drawer-item__remove').forEach(button => {
      button.addEventListener('click', () => {
        this.removeItem(button);
        document.dispatchEvent(this.wishlistItemsUpdated);
      })
    });
  }

  setHeaderIndicator() {
    if (this.wishlistItems.length >= 1) {
      this.headerButton.classList.add('has-items');
    } else if (this.wishlistItems.length === 0 && this.headerButton.classList.contains('has-items')) {
      this.headerButton.classList.remove('has-items');
    }
  }

  setWishlistButtons() {
    if (!this.wishlistItems) return;

    this.wishlistButtons.forEach(button => {
      if (this.wishlistItems.some(item => item.id === button.dataset.id)) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    })
  }

  toggleButton(button) {
    if (button.classList.contains('active')) {
      this.removeItem(button)
    } else {
      this.addItem(button)
    }

    document.dispatchEvent(this.wishlistItemsUpdated);
  }

  removeItem(button) {
    const updatedItems = this.wishlistItems.filter(wishlistItem => wishlistItem.id !== button.dataset.id);
    this.wishlistItems = updatedItems;
    this.updateLocalStorage();

    if (!this.appDataLoaded) {
      this.removedItemsCache.push(button.dataset.id)
    }

    button.classList.remove('active');
    RemoveFromSmartWishlist(button.dataset.id, button.dataset.variant_id);
  }
  
  addItem(button) {
    this.addToWishlistItems({
        handle: button.dataset.handle,
        id: button.dataset.id,
        image: button.dataset.image,
        title: button.dataset.title,
        variant_id: button.dataset.variant_id,
        variant_price: button.dataset.variant_price,
        variant_title: button.dataset.variant_title,
    })

    this.updateLocalStorage();
    
    button.classList.add('active');
    AddToSmartWishlist(button.dataset.id, button.dataset.variant_id);
  }

  addToWishlistItems(item) {
    // Accepts an item object
    if (this.validateItemObject(item)) {
      if (!this.wishlistItems.some(wishlistItem => wishlistItem.id === item.id)) {
        this.wishlistItems.push(item);
      }
    }
  }

  validateItemObject(object) {
    const requiredProperties = [
      'handle', 'id', 'image', 'title', 'variant_id', 'variant_price', 'variant_title'
    ];
  
    for (const property of requiredProperties) {
      if (!object[property] || object[property] === '') {
        console.log(`Wishlist - Invalid item object: Missing or empty property "${property}"`);
        return false;
      }
    }
  
    return true;
  }

  updateLocalStorage() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.wishlistItems));
  }

  fetchLocalData() {
    const localData = JSON.parse(localStorage.getItem(this.storageKey))

    if (!localData) return;

    localData.forEach(item => {
      this.addToWishlistItems({
        handle: item.handle,
        id: item.id,
        image: item.image,
        title: item.title,
        variant_id: item.variant_id,
        variant_price: item.variant_price,
        variant_title: item.variant_title,
      })
    })

    document.dispatchEvent(this.wishlistItemsUpdated);
  }

  fetchAppData() {
    const wishlist = this;
    const appDataLoaded = new Event("appDataLoaded");

    // For logged out users
    const wishlistid = SWGetExpressWishlistId();
    var xhr = new XMLHttpRequest();
    xhr.open('GET', "/a/wishlist?type=api&wishlistid=" + wishlistid + "&version=1", true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 200) {
        try {
          var data = JSON.parse(xhr.responseText);
        } catch {
          console.log('Not able to parse Wishlist app data')
          return;
        }
        wishlist.appData = data;
        document.dispatchEvent(appDataLoaded);
      }
    };
    xhr.send(null);

    // For logged in users
    var customerid=SWGetCustomerWishlistId();
    if (customerid != 0) { //check if user is logged in
      var xhr2 = new XMLHttpRequest();
      xhr2.open('GET', "/a/wishlist?type=api&customerid=" + customerid + "&version=1", true);
      xhr2.setRequestHeader('Content-Type', 'application/json');
      xhr2.onreadystatechange = function() {
        if (xhr2.readyState === 4 && xhr2.status === 200) {
          var data = JSON.parse(xhr2.responseText);
          wishlist.appData = data;
          document.dispatchEvent(appDataLoaded);
        }
      };
      xhr2.send(null);
    }
  }

  drawerOpen() {
    console.log('hi')
    setTimeout(() => {this.drawer.classList.add('animate', 'active')});
    this.overlay.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  drawerClose() {
    this.overlay.classList.remove('active');
    this.drawer.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden-tablet');
  }
}

function SWCallbackWishlistButtonLoaded() {
  new Wishlist;
}